export default __webpack_public_path__ + "static/media/truck_man_card_read_image.c9454b78.png";